// src/components/user/controltower/RegularDeliveryCard.jsx
import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';

const STATUS_STYLES = {
  pending:   { bar: 'bg-orange-400', badge: 'bg-orange-100 text-orange-700', label: 'Pendiente'  },
  encamino:  { bar: 'bg-blue-400',   badge: 'bg-blue-100 text-blue-700',     label: 'En Camino'  },
  entregado: { bar: 'bg-green-400',  badge: 'bg-green-100 text-green-700',   label: 'Entregado'  },
  cancelado: { bar: 'bg-red-400',    badge: 'bg-red-100 text-red-700',       label: 'Cancelado'  },
  rechazado: { bar: 'bg-red-400',    badge: 'bg-red-100 text-red-700',       label: 'Rechazado'  },
};

export function RegularDeliveryCard({ delivery, onClick, isSelected }) {
  const s = STATUS_STYLES[delivery.status] || { bar: 'bg-slate-300', badge: 'bg-slate-100 text-slate-600', label: delivery.status };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left flex items-stretch transition-colors ${
        isSelected ? 'bg-brand-primary/5' : 'hover:bg-slate-50'
      }`}
    >
      {/* Status color bar */}
      <div className={`w-1 flex-shrink-0 ${s.bar}`} />

      <div className="flex-1 px-3 py-3 space-y-1.5 min-w-0">
        {/* Header */}
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 min-w-0">
            <span className="text-xs font-bold text-slate-400 font-montserrat shrink-0">#{delivery.id}</span>
            <p className="text-sm font-bold text-slate-900 font-montserrat truncate">{delivery.recipient_name}</p>
          </div>
          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full font-montserrat shrink-0 ${s.badge}`}>
            {s.label}
          </span>
        </div>

        {/* Address */}
        <div className="flex items-start gap-1.5">
          <MapPin className="w-3 h-3 text-slate-400 mt-0.5 shrink-0" />
          <p className="text-xs text-slate-600 font-montserrat line-clamp-1">
            {delivery.address}, {delivery.district}
          </p>
        </div>

        {/* Phone + arrival */}
        <div className="flex items-center gap-3">
          {delivery.recipient_phone && (
            <div className="flex items-center gap-1">
              <Phone className="w-3 h-3 text-slate-400" />
              <span className="text-xs text-slate-500 font-montserrat">{delivery.recipient_phone}</span>
            </div>
          )}
          {delivery.arrival_time && (
            <div className="flex items-center gap-1 ml-auto">
              <Clock className="w-3 h-3 text-slate-400" />
              <span className="text-xs text-slate-500 font-montserrat">
                {new Date(delivery.arrival_time).toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
          )}
        </div>
      </div>
    </button>
  );
}